import { graphql } from '@teachino/shared-infrastructure';
import { courseFragment } from './material-course.fragment';

export const materialCoursesQuery = graphql(
  `
    query MaterialCourses($itemId: String!) {
      coursesForItem(itemIdInput: { id: $itemId }) {
        ...MaterialCourse
      }
    }
  `,
  [courseFragment],
);
